<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account_costcentre"
        :primary-fields="[ 'name', 'description' ]"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <CostCentreTable
          ref="table"
          :filters="filters"
          :account-id="$route.params.accountId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import CostCentreTable from '@/components/Application/Manage/Account/CostCentreTable'

export default {
  components: {
    Filters,
    CostCentreTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Cost Centres',
        route: { name: 'manage-accounts-account-cost-centres', params: { accountId: this.$route.params.accountId } }
      },
      filters: []
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  }
}
</script>
